import api from '@/libs/axios'

export default {
  async create(payload) {
    const response = await api.post('/admin/stage-words', payload)
    return response
  },
  async update(payload) {
    let response = await api.put('/admin/stage-words', payload)
    return response
  },
  async delete(payload) {
    const response = await api.delete('/admin/stage-words', {
      data: payload,
    })
    return response
  },
  async getList(params) {
    const response = await api.get('/admin/stage-words', { params })
    return response
  },
  async get(params) {
    let response = await api.get('/admin/stage-words/detail', {
      params,
    })
    return response.data.data.document || null
  },
  async getRelateStages(params) {
    let response = await api.get('/admin/stage-words/relate-stages', {
      params,
    })
    return response.data.data.document || null
  },
  async getWords(params){
    const response = await api.get('/admin/stage-words/all', { params })
    return response
  },
  async getIds(params){
    const response = await api.get('/admin/stage-words/get-ids', { params })
    return response
  }
}